import { BrowserModule } from '@angular/platform-browser';
import { NgModule, APP_INITIALIZER, ErrorHandler } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import {
  HTTP_INTERCEPTORS,
  HttpClientModule,
  HttpClient,
} from '@angular/common/http';
import { HttpHelperService } from './shared/services/http-helper.service';
import { CookieService } from 'ngx-cookie-service';
import { AuthService } from './shared/services/auth.service';
import { ToastrModule } from 'ngx-toastr';
import { AppInterceptor } from './app.interceptor';
import { NgxPermissionsModule } from 'ngx-permissions';
import { HeaderComponent } from './common/header/header.component';
import { SidebarComponent } from './common/sidebar/sidebar.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule } from '@angular/router';
import { EnvService } from './core/services/env.service';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { ModalModule } from 'ngx-bootstrap/modal';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MAT_SELECT_CONFIG } from '@angular/material/select';
import { MatTooltipModule } from '@angular/material/tooltip';
import { LogoutConfirmationDialogModule } from './common/logout-confirmation-dialog/logout-confirmation-dialog.module';
import { ChangePasswordComponent } from './common/change-password/change-password.component';
import { AlertModule } from './common/alert/alert.module';
import { NgChartsModule } from 'ng2-charts';
import { CloneConfirmationDialogModule } from './common/clone-confirmation-dialog/clone-confirmation-dialog/clone-confirmation-dialog.module';
import { RolePermissionService } from './core/services/role-permission.service';
import { DatePipe } from '@angular/common';
import { NotificationIconComponent } from './common/header/notification-icon/notification-icon.component';
import { AssessmentSummaryModule } from './components/assessment-summary/assessment-summary.module';
import { QuestionDetailsNameEditModule } from './common/questionnaire/question-details-name-edit/question-details-name-edit.module';
import { NgProgressModule } from 'ngx-progressbar';
import { NgProgressHttpModule } from 'ngx-progressbar/http';
import { ActivatePersonConfirmationDialogModule } from './common/activate-person-confirmation-dialog/activate-person-confirmation-dialog.module';
import { EmailAssessmentModule } from './components/email-assessment/email-assessment.module';
import { SuperadminHomeComponent } from './components/superadmin-home/superadmin-home.component';
import { OAuthModule } from 'angular-oauth2-oidc';
// import { Adb2cLoginComponent } from './components/adb2c-login/adb2c-login.component';
import { SessionPopupComponent } from './common/session-popup/session-popup.component';
import { SessionService } from './shared/services/session.service';
import { ErrorLogService } from './shared/services/error-log.service';
import { GlobalErrorHandlerService } from './shared/services/global-error-handler.service';
import { MatLegacyAutocompleteModule as MatAutocompleteModule } from '@angular/material/legacy-autocomplete';
import { ConfirmationpopupModule } from './common/confimation-popup/confimation-popup.module';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { WatchVideoPopupComponent } from './common/watch-video-popup/watch-video-popup.component';
import { MatLegacyDialogModule as MatDialogModule, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA, MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DEFAULT_OPTIONS as MAT_DIALOG_DEFAULT_OPTIONS } from '@angular/material/legacy-dialog';
// this includes the core NgIdleModule but includes keepalive providers for easy wireup
import { NgIdleKeepaliveModule } from '@ng-idle/keepalive';
import { NgxMaskDirective, NgxMaskPipe, provideNgxMask } from 'ngx-mask';
import { SharedModule } from './shared/shared/shared.module';
import {FullscreenOverlayContainer, OverlayContainer, OverlayModule} from '@angular/cdk/overlay';
import { CustomOverlayComponentComponent } from './common/custom-overlay-component/custom-overlay-component.component';
import { EnvLocalService } from './core/services/env-local.service';
import { EnvDevService } from './core/services/env-dev.service';
import { EnvQAService } from './core/services/env-qa.service';
import { EnvStageService } from './core/services/env-stage.service';
import { EnvDemoService } from './core/services/env-demo.service';
import { EnvTrainingService } from './core/services/env-training.service';
import { EnvCdssDevService } from './core/services/env-cdss-dev.service';
import { EnvCdssQaService } from './core/services/env-cdss-qa.service';
import { EnvCdssSitService } from './core/services/env-cdss-sit.service';
import { EnvCdssIntService } from './core/services/env-cdss-int.service';
import {EnvCdssPerfService  } from './core/services/env-cdss-perf.service';
import {EnvCDSSProdService  } from './core/services/env-cdss-prod-service';
import { EnvMagellanDevService } from './core/services/env-magellandev.service';
import { EnvMagellanQaService } from './core/services/env-magellanqa.service';
import { EnvProd1Service } from './core/services/env-prod1.service';
import { EnvProdService } from './core/services/env-prod.service';
import { EnvMagellanUatService } from './core/services/env-magellan-uat.service';
import { AuthCallbackComponent } from './components/auth-callback/auth-callback.component';
import { CachedTranslateHttpLoader } from './core/services/cached-translation-loader.service';

// AoT requires an exported function for factories
export function HttpLoaderFactory(http: HttpClient) {
  return new CachedTranslateHttpLoader(http, 'assets/i18n/', '.json');
}


@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    SidebarComponent,
    ChangePasswordComponent,
    NotificationIconComponent,
    SuperadminHomeComponent,
    SessionPopupComponent,
    WatchVideoPopupComponent,
    CustomOverlayComponentComponent,
    AuthCallbackComponent,
  ],
  imports: [
    SharedModule,
    NgIdleKeepaliveModule.forRoot(),
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    ToastrModule.forRoot(),
    NgxPermissionsModule.forRoot(),
    BrowserAnimationsModule,
    RouterModule,
    ReactiveFormsModule,
    FormsModule,
    NgChartsModule,
    ModalModule.forRoot(),
    MatFormFieldModule,
    MatInputModule,
    MatTooltipModule,
    MatAutocompleteModule,
    MatDialogModule,
    LogoutConfirmationDialogModule,
    AlertModule,
    NgxMatSelectSearchModule,
    CloneConfirmationDialogModule,
    AssessmentSummaryModule,
    QuestionDetailsNameEditModule,
    NgProgressModule.withConfig({
      spinnerPosition: 'left',
      color: 'red'
    }),
    NgxMaskPipe,
    NgxMaskDirective,
    NgProgressHttpModule,
    ActivatePersonConfirmationDialogModule,
    EmailAssessmentModule,
    ConfirmationpopupModule,
    OverlayModule,
    OAuthModule.forRoot({
      resourceServer:
      {
        // allowedUrls: ['https://localhost:5001/api'],
        sendAccessToken: true
      }
    }),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    })
  ],
  providers: [
    {
      provide: APP_INITIALIZER,
      useFactory: (envService: EnvService) => () => envService.init(),
      deps: [EnvService],
      multi: true,
    },
    HttpHelperService,
    RolePermissionService,
    AuthService,
    SessionService,
    ErrorLogService,
    {
      provide: ErrorHandler,
      useClass: GlobalErrorHandlerService
    },
    CookieService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AppInterceptor,
      multi: true,
    },
    {
      provide: MAT_DIALOG_DATA,
      useValue: {}
    },
    {
      provide: MatDialogRef,
      useValue: {}
    },
    {
      provide: MAT_DIALOG_DEFAULT_OPTIONS,
      useValue: {
        hasBackdrop: false
      }
    },
    {provide: OverlayContainer, useClass: FullscreenOverlayContainer}, EnvLocalService,EnvDevService,EnvQAService,
    EnvStageService,EnvDemoService,EnvTrainingService,EnvCdssDevService,EnvCdssQaService,EnvCdssSitService,
    EnvCdssIntService,EnvMagellanDevService,EnvMagellanQaService,EnvProd1Service,EnvProdService,EnvMagellanUatService,
    EnvCdssPerfService,
    EnvCDSSProdService,
    DatePipe,
    {
      provide: MAT_SELECT_CONFIG,
      useValue: { hideSingleSelectionIndicator: true }
    },
    provideNgxMask()
  ],
  bootstrap: [AppComponent],
  exports: [
    RouterModule,
    MatFormFieldModule,
    MatInputModule,
    MatAutocompleteModule
  ],
})
export class AppModule { }
